import { ReloadAction, ReloadKeys, ReloadMessage } from './actions';

export type ReloadState = {
    showReload: boolean;
    message: ReloadMessage;
};

export const initialState: ReloadState = {
    showReload: false,
    message: {},
};
export const reloadReducer = (state = initialState, action: ReloadAction): ReloadState => {
    switch (action.type) {
    case ReloadKeys.SHOW_RELOAD:
        return {
            ...state,
            showReload: true,
            message: action.message,

        };
    case ReloadKeys.CLOSE_RELOAD:
        return {
            ...state,
            showReload: false,
            message: {},
        };
    default:
        return state;
    }
};
